module.exports = __webpack_public_path__ + "img/pic1.ec252f36.png";